import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useContext } from 'react';
import { clickBaseEvent } from '@chegg-me-components/utils';
import { rioClient } from '../../rio';
import { HeaderContext, useElementRectInfo } from '../../shared';
import { MenuList, MenuListItem, MenuItemLink } from '../../styles/menuItemsList';
import { VisuallyHidden } from '../../styles/root';

var MenuItemsList = function MenuItemsList(_ref) {
  var listIndex = _ref.listIndex,
      itemsList = _ref.itemsList,
      activeItem = _ref.activeItem,
      breadcrumbs = _ref.breadcrumbs,
      isMobile = _ref.isMobile;

  var _useContext = useContext(HeaderContext),
      envUrl = _useContext.envUrl,
      dataTestPrefix = _useContext.dataTestPrefix;

  return /*#__PURE__*/React.createElement(MenuList, {
    "data-test": "".concat(dataTestPrefix, "-menu-list-").concat(listIndex),
    "aria-label": breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs[breadcrumbs.length - 1]
  }, itemsList.map(function (_ref2, index) {
    var text = _ref2.text,
        href = _ref2.href,
        useAbsolute = _ref2.useAbsolute,
        target = _ref2.target,
        _onClick = _ref2.onClick;
    var isActive = activeItem === text;

    var _useElementRectInfo = useElementRectInfo(),
        rectInfo = _useElementRectInfo.rectInfo,
        elementRef = _useElementRectInfo.elementRef;

    return /*#__PURE__*/React.createElement(MenuListItem, {
      key: index,
      "data-test": "".concat(dataTestPrefix, "-menu-list-item-").concat(index)
    }, /*#__PURE__*/React.createElement(MenuItemLink, {
      href: useAbsolute ? href : envUrl + href,
      target: target,
      onClick: function onClick(e) {
        rioClient.sendEvent(_objectSpread(_objectSpread({}, clickBaseEvent), {}, {
          data: {
            interaction: {
              element: {
                name: 'nav menu item',
                type: 'link',
                region_name: "".concat(isMobile ? 'side nav' : 'top nav', "|").concat(breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.join('|').toLowerCase()),
                text: text,
                value: text.toLowerCase()
              },
              type: 'select'
            }
          }
        }));
        /* istanbul ignore next */

        _onClick === null || _onClick === void 0 ? void 0 : _onClick(e);
      },
      "data-test": "".concat(dataTestPrefix, "-menu-list-item-").concat(index, "-link"),
      isActive: isActive,
      ref: elementRef,
      positionX: rectInfo === null || rectInfo === void 0 ? void 0 : rectInfo.x
    }, isActive && /*#__PURE__*/React.createElement(VisuallyHidden, {
      "data-test": "".concat(dataTestPrefix, "-menu-list-current-item-").concat(index)
    }, "Current page:", ' '), text));
  }));
};

MenuItemsList.displayName = 'MenuItemsList';
export default MenuItemsList;